export enum TeamRole {
  ADMIN = "admin",
  MEMBER = "member",
}
export interface ITeam {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  members: IMember[];
  fieldOfOperations: string;
  regionOfOperations: string;
  isNgo: boolean;
  foundationYear: number;
  quantityOfMembers: number;
  quantityOfInstitutionalMembers: number;
  quantityOfEmployees: number;
  about: string;
  website: string;
  email: string;
  contactNumber: string;
  teamUsers: {
    userId: number;
    teamId: number;
    teamRole: `${TeamRole}`;
  }[];
}
export interface ITeamResponse {
  teams: ITeam[];
  count: number;
}
export interface IMember {
  userId: number;
  name: string;
  email: string;
  teamRole: TeamRole;
}
